import type { CollectionMode, PaymentMethodState } from "@/types/api";
import { http } from "./http";

/**
 * Auto-pay: the mandate an org authorizes, and whether their contract can carry
 * one at all.
 *
 * Kept apart from billingService because it is a different kind of work — this
 * is standing permission to charge, not what is owed. `availability` comes back
 * with the mandate rather than being derived here: whether a debit fits under
 * the cap depends on the org's current price, which only the server knows.
 */
export const paymentMethodService = {
	get: (signal?: AbortSignal) =>
		http.get<PaymentMethodState>("/api/org/billing/payment-method", { signal }),

	/** Starts an authorization; returns a hosted URL to open at the bank. */
	register: (
		body: { method?: string; capCents?: number; contact?: string } = {},
	) =>
		http.post<{ mandate_id: string; registration_url: string | null }>(
			"/api/org/billing/payment-method",
			body,
		),

	revoke: (id: string) =>
		http.del<{ ok: true }>(`/api/org/billing/payment-method/${id}`),

	setCollectionMode: (mode: CollectionMode) =>
		http.put<{ collection_mode: CollectionMode }>(
			"/api/org/billing/collection-mode",
			{ mode },
		),
};
